<template>
  <b-col class="tests-content-container">
    <b-row>
      <b-col class="p-0">
        <h2 class="pl-sm-5 pt-4">Test Tool GUI</h2>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="p-0">
        <b-nav tabs class="pl-sm-5 pr-sm-5">
          <b-nav-item :active="isNew" :to="{ name: 'newtest'}">New test</b-nav-item>
          <b-nav-item :active="isOngoing" :to="{ name: 'ongoingtests'}">Ongoing tests</b-nav-item>
          <b-nav-item :active="isFinalised" :to="{ name: 'finalisedtests'}">Finalised tests</b-nav-item>
        </b-nav>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
export default {
  name: 'TestsTabs',
  props: {
    isNew: {
      type: Boolean,
      required: false,
      default: () => false
    },
    isOngoing: {
      type: Boolean,
      required: false,
      default: () => false
    },
    isFinalised: {
      type: Boolean,
      required: false,
      default: () => false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/TestsTabs.vue